export default {
      id: "common__status_not_notify-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__status_not_notify",
      toString: function () {
        return this.url;
      }
    }